import {
  UPDATE_PRODUCT_BY_FABRIC,
  UPDATE_PRODUCT_BY_BUTTON,
  UPDATE_PRODUCT_BY_DETAIL,
  UPDATE_PRODUCT_BY_CONTRAST,
  UPDATE_PRODUCT_BY_CONTRAST_TYPE,
  UPDATE_SHIRT_RENDER,
  UPDATE_SELECTED_DETAIL,
  UPDATE_SELECTED_BUTTON,
  UPDATE_SELECTED_FABRIC,
  UPDATE_SELECTED_CONTRAST,
  UPDATE_SHIRT_PRICE_BY_FABRIC,
  UPDATE_SHIRT_PRICE_BY_BUTTONS,
  UPDATE_SHIRT_PRICE_BY_ATTR,
  UPDATE_SHIRT_PRICE_BY_CONTRAST,
  // RESET_EMBROIDERY,
} from '../constants/actionTypes';

import { batchActions } from 'redux-batched-actions';
import {
  change
} from 'redux-form';

import {
  getUpdatedRenderDetail,
  getUpdatedRenderFabric,
  getUpdatedRenderButtons,
  getUpdatedRenderContrasts
} from '../selectors/entities/render';

import {
  getAttrDataValueEnums,
  getAttrDataValueButtons,
  getAttrDataValueFabrics,
  getAttrDataValueContrasts,

  getAttrPrice,
  getFabricPrice,
  getContrastPrice,
} from '../selectors/entities/general';
import { getSelectedFabricValues } from '../selectors/entities/general'


export function onFabricChanged(value) {


  return (dispatch, getState) => {
    const name = 'fabric'
    dispatch({
      type: UPDATE_PRODUCT_BY_FABRIC,
      value,
      name,
    }, getState())
    dispatch({
      type: UPDATE_SELECTED_FABRIC,
      name,
      data: getAttrDataValueFabrics(getState())
    })
    dispatch({
      type: UPDATE_SHIRT_PRICE_BY_FABRIC,
      payload: getFabricPrice(getState())
    })
    dispatch({
      type: UPDATE_SHIRT_RENDER,
      render: getUpdatedRenderFabric(getState())
    })
  };
}

export function onButtonChanged(value) {

  return (dispatch, getState) => {
    const name = 'buttons'
    dispatch({
      type: UPDATE_PRODUCT_BY_BUTTON,
      name,
      value
    })
    dispatch({
      type: UPDATE_SELECTED_BUTTON,
      name,
      data: getAttrDataValueButtons(getState())
    })
    dispatch({
      type: UPDATE_SHIRT_PRICE_BY_BUTTONS,
      payload: getAttrPrice(getState())
    })
    dispatch({
      type: UPDATE_SHIRT_RENDER,
      render: getUpdatedRenderButtons(getState())
    })
    dispatch(
      change('detail', name, value),
      getState()
    )
  };
}

export function onDetailChanged(
  value,
  name,
  updatePrice = false,
  updateRender = false
) {
  return (dispatch, getState) => {
    dispatch({
      type: UPDATE_PRODUCT_BY_DETAIL,
      name,
      value,
    })
    dispatch({
      type: UPDATE_SELECTED_DETAIL,
      name,
      data: getAttrDataValueEnums(getState())
    })
    if (updatePrice) {
      dispatch({
        type: UPDATE_SHIRT_PRICE_BY_ATTR,
        payload: getAttrPrice(getState())
      })
    }
    if (updateRender) {
      dispatch({
        type: UPDATE_SHIRT_RENDER,
        render: getUpdatedRenderDetail(getState())
      })
    }
    dispatch(
      change('detail', name, value),
      getState()
    )
  }
}

export function onContrastChanged(value, name) {

  return (dispatch, getState) => {
    dispatch({
      type: UPDATE_PRODUCT_BY_CONTRAST,
      value,
      name,
    });

    dispatch({
      type: UPDATE_PRODUCT_BY_CONTRAST_TYPE,
      name,
    }, getState());

    dispatch({
      type: UPDATE_SELECTED_CONTRAST,
      data: getAttrDataValueContrasts(getState())
    }, getState());


    dispatch(batchActions([
      {
        type: UPDATE_SHIRT_RENDER,
        render: getUpdatedRenderContrasts(getState())
      },
      {
        type: UPDATE_SHIRT_PRICE_BY_CONTRAST,
        payload: getContrastPrice(getState())
      },
    ]), getState());

  }
}

export function cleanSelectedContrast(name) {
  return (dispatch, getState) => {
    const selectedFabric = getSelectedFabricValues(getState())
    const value = selectedFabric.article

    dispatch({
      type: UPDATE_PRODUCT_BY_CONTRAST,
      value,
      name,
    });

    dispatch(batchActions([
      {
        type: UPDATE_SHIRT_RENDER,
        render: getUpdatedRenderContrasts(getState())
      },
    ]), getState());
  };
}

export function onContrastTypeChanged(data) {

  return (dispatch) => {
    dispatch({
      type: 'CONTRAST_TYPE_CHANGED',
      data,
    })
  };
}


export function cleanContrasts() {
  return (dispatch, getState) => {

    const contrastFields = ['collarFabric', 'cuffFabric', 'cuffTurnFabric', 'collarStandFabric', 'fasteningButtonsFabric']; 
    contrastFields.forEach(item => {
      dispatch(onContrastChanged(null, item), getState());
      dispatch(cleanSelectedContrast(item), getState());
    })
  }
}